import React from 'react';

import { Card, Row, Col } from "react-bootstrap";

const Home = () => {
    
    return ( 
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Home</h1>
                    <hr />
                </Col>
            </Row>

            
        </>
     );
}
 
export default Home;